import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppRooute } from 'src/app/core/common/app-route.model';
import { AppSettings } from 'src/app/core/common/app-settings';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { StateConstant } from 'src/app/core/common/state-constant';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { SocioService } from 'src/app/core/services/caso/socio.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { SocioVo } from 'src/app/shared/models/caso/socio/socio-vo.model';
import { SocioFormComponent } from '../socio-form/socio-form.component';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'vex-socio-list',
  templateUrl: './socio-list.component.html',
  styleUrls: ['./socio-list.component.scss']
})
export class SocioListComponent implements OnInit {

  appSettings = AppSettings;
  stateConstant = StateConstant;

  dataSource: MatTableDataSource<SocioVo>;
  displayedColumns: string[] = ['razonSocial', 'contacto', 'documento', 'email', 'celular', 'hasWhatsapp', 'firebaseInstance', 'fechaRegistro', 'usuarioRegistro', 'actions'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  selection = new SelectionModel<SocioVo>(true, []);
  searchKey: string;

  socioService = inject(SocioService);
  socios: SocioVo[];

  crumbs: AppRooute[] = [RouteConstant.ROUTE_CASE_SOCIO];

  constructor(private dialog: MatDialog,
    private router: Router,
    private toatrService: ToastrService) {

  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.socioService.findAll().subscribe(
      response => {
        this.socios = response.data;
        this.dataSource = new MatTableDataSource(response.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      err => {
        console.error(err);
      }
    )
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  create() {
    const dialogRef = this.dialog.open(SocioFormComponent, {
      width: AppSettings.DIALOG_WIDTH,
      data: {
        operation: OperacionEnum.create,
        title: 'Nuevo socio',
        button: AppSettings.DIALOG_BUTTON_PERSIST_POSITIVE
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadList();
      }
    });
  }

  edit(vo: SocioVo) {
    const dialogRef = this.dialog.open(SocioFormComponent, {
      width: AppSettings.DIALOG_WIDTH,
      data: {
        operation: OperacionEnum.update,
        title: 'Actualizar socio',
        button: AppSettings.DIALOG_BUTTON_UPDATE_POSITIVE,
        entity: vo
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadList();
      }
    });
  }

  delete(vo: SocioVo) {
    const dialogData = new ConfirmDialogModel("Eliminar socio", "¿Está seguro de eliminar el registro selecionado?");
    this.dialog
      .open(ConfirmDialogComponent, {
        data: dialogData
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.socioService.delete(vo.id).subscribe(
            response => {
              if (response.status) {
                this.toatrService.success(response.message);
                this.loadList();
              } else {
                this.toatrService.warning(response.message);
              }
            },
            err => {
              this.toatrService.error(err.data);
            }
          )
        }
      });
  }

  downloadPdf() {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });
    doc.addFont('assets/fonts/PTSans.ttf', 'PTSans', 'normal');
    let bodyData: any[] = [];
    this.socios.forEach(function (socio) {
      bodyData.push([socio.razonSocial, socio.contacto, socio.documento, socio.email, socio.celular, socio.hasWhatsapp ? 'SI' : 'NO', socio.firebaseInstance !== null ? 'SI' : 'NO', socio.fechaRegistro, socio.usuarioRegistro]);
    });
    console.log(bodyData);
    autoTable(doc, {
      head: [['Razon social', 'Contacto', 'Documento', 'Email', 'Celular', 'Tiene whatsapp', 'Firebase Instance', 'Fecha registro', 'Fecha Usuario registro']],
      body: bodyData,
      styles: {
        fontSize: 6
      }
    })
    doc.save('desaparecidos.pdf')
  }
}
